import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router";
import Signup from "./components/Signup.js";
import Chat from "./components/Chat.js";
import Login from "./components/Login.js";
import Home from "./components/Home.js";
import Explore from "./components/Explore.js";
import { AuthProvider } from "./context/AuthContext.js";
import { ThemeProvider } from "./context/ThemeContext.js";
import QueryProvider from "./context/QueryProvider.js";
import { CourseProvider } from "./context/CourseContext.js";
import WorkSpacesList from "./components/WorkSpacesList.js";
import Join from "./components/Join.js";
import Header from "./components/Header.js";
import CourseDetails from "./components/CourseDetails.js";
import Classes from "./components/Classes.js";
import Learners from "./components/Learners.js";
import SocketLayout from "./components/SocketLayout.js";
import LiveClass from "./components/LiveClass.js";
import ChoosePlan from "./components/ChoosePlan.js";
import SubscriptionVerfication from "./components/SubscriptionVerfication.js";
import OwnerPayoutSetup from "./components/OwnerPayoutSetup.js";
import GroupMemberships from "./components/GroupMemberships.js";
import GroupSettings from "./components/GroupSettings.js";
import ManualPayouts from "./components/ManualPayouts.js";

const App = () => {
  return <Home />;
};

const routes = [
  { path: "/join/group/:slug", element: <Join /> },
  { path: "/payouts", element: <ManualPayouts /> },
  { path: "/owner-payouts", element: <OwnerPayoutSetup /> },
  { path: "/group-memberships", element: <GroupMemberships /> },
  { path: "/explore", element: <Explore /> },
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/signup",
    element: <Signup />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/courses",
    element: <WorkSpacesList />,
  },
  {
    path: "/choose-plan",
    element: <ChoosePlan />,
  },
  {
    path: "/subscription-verification",
    element: <SubscriptionVerfication />,
  },
  {
    path: "/subscription-successful",
    element: <SubscriptionVerfication />,
  },
  {
    path: "/courses/:slug",
    children: [
      {
        element: <Header />,
        children: [
          {
            index: true,
            element: <CourseDetails />,
          },
          {
            path: "classes",
            element: <Classes />,
          },
          {
            path: "learners",
            element: <Learners />,
          },
          {
            path: "messages",
            element: <Chat />,
          },
          { path: "settings", element: <GroupSettings /> },
          {
            path: "classes/:classId/live",
            element: <LiveClass />,
          },
        ],
      },
    ],
  },

  {
    path: "/join/:courseName/:inviteCode/:inviterName/:memberCount",
    element: <Join />,
  },
];

const appRouter = createBrowserRouter([
  {
    element: <SocketLayout />,
    children: routes,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider><AuthProvider>
    <QueryProvider>
    <CourseProvider>
      <RouterProvider router={appRouter} />
    </CourseProvider>
    </QueryProvider>
  </AuthProvider></ThemeProvider>,
);
